import React, { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import {
  OauthPlatform,
  useGetOauthTokensQuery,
} from '../../graphql/generated/graphql'
import { usePageNavigation } from 'hooks/useNavigation'
import Spinner from 'components/Spinner/Spinner'

export default function Reddit(): JSX.Element {
  const [searchParams] = useSearchParams()
  const code = searchParams.get('code')
  const errorParam = searchParams.get('error')
  const { navigateToDashboard } = usePageNavigation()
  const navigate = useNavigate()

  useEffect(() => {
    if (errorParam) {
      alert('User denied Reddit access')
      navigate('/connect')
    }
  }, [errorParam, navigate])

  const { loading, data, error } = useGetOauthTokensQuery({
    variables: {
      code: code ?? '',
      platform: OauthPlatform.Reddit,
    },
    skip: !code,
  })

  useEffect(() => {
    if (data?.oauth?.accessToken) {
      localStorage.setItem('reddit_access_token', data.oauth.accessToken)
      if (data.oauth.refreshToken) {
        localStorage.setItem('reddit_refresh_token', data.oauth.refreshToken)
      }
      navigateToDashboard()
    }
  }, [data, navigateToDashboard])

  if (!code)
    return (
      <div style={{ textAlign: 'center', marginTop: '100px' }}>
        <h2>Missing Authorization Code</h2>
        <p>No code received from Reddit</p>
        <button onClick={() => navigate('/connect')}>Go back to Connect</button>
      </div>
    )

  if (loading)
    return (
      <div
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
        }}
      >
        <Spinner />
        <p style={{ marginTop: '20px', fontSize: '16px' }}>
          Connecting your Reddit account...
        </p>
      </div>
    )

  if (error ?? !data)
    return (
      <div style={{ textAlign: 'center', marginTop: '100px', padding: '20px' }}>
        <h2 style={{ color: '#ff4444' }}>Connection Failed</h2>
        <p style={{ fontSize: '16px', marginTop: '20px' }}>
          {error?.message ??
            'Something went wrong connecting your Reddit account'}
        </p>
        <button
          onClick={() => navigate('/connect')}
          style={{
            marginTop: '20px',
            padding: '10px 20px',
            fontSize: '14px',
            cursor: 'pointer',
          }}
        >
          Try Again
        </button>
      </div>
    )

  return (
    <div style={{ textAlign: 'center', marginTop: '100px' }}>
      <h2 style={{ color: '#4caf50' }}>✓ Successfully Connected!</h2>
      <p>Redirecting to dashboard...</p>
    </div>
  )
}
